module.exports = __webpack_public_path__ + "static/Smiling-call-center-agent-1039676 2-1b37413f4b5b3db555965cde431c9d03.png";